import { render, staticRenderFns } from "./Amex.vue?vue&type=template&id=4f29eae6"
import script from "./Amex.vue?vue&type=script&lang=js"
export * from "./Amex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports